module.exports = __webpack_public_path__ + "static/media/jmlogo.b21d5575.glb";


//////////////////
// WEBPACK FOOTER
// ./src/constants/jmlogo.glb
// module id = 95
// module chunks = 0